<template>
	<div>
		<div class="shop-list-main">
			<el-form :inline="true" :model="ShopListFromLine" class="demo-form-inline">
				
			  <el-form-item label="店铺名称" class="from-label" >
			    <el-input size="small" v-model="ShopListFromLine.ShopName" placeholder="请输入店铺名称" clearable></el-input>
			  </el-form-item>
				
				<!-- <el-form-item label="店主" class="from-label">
				  <el-input size="small" v-model="ShopListFromLine.UserName" placeholder="请输入店主地址" clearable></el-input>
				</el-form-item> -->
				
				<el-form-item label="地址" class="from-label">
				  <el-input size="small" v-model="ShopListFromLine.ShopDir" placeholder="请输入店铺地址" clearable></el-input>
				</el-form-item>
				
			  <el-form-item>
			    <el-button type="primary" @click="queryData" size="small" icon="el-icon-search">查询</el-button>
					<el-button type="primary" @click="onReset" size="small" icon="el-icon-refresh">重置</el-button>
			  </el-form-item>
				
			</el-form>
			
			<div style="margin-bottom: 20px;">
				<el-button type="primary" icon="el-icon-plus"
				 size="mini" plain
				 @click="add_shop"
				 >新增</el-button>
				
				<el-button type="success" icon="el-icon-edit"
				 size="mini" plain :disabled="b_top_change_btn"
				 @click="change_shop(multipleSelection[0])"
				 >修改</el-button>
				
				<el-button type="warning" icon="el-icon-search"
				 size="mini" plain :disabled="b_top_find_btn"
				 @click="show_shop(multipleSelection[0])"
				 >查询</el-button>
				
				<el-button type="danger" icon="el-icon-delete"
				 size="mini" plain :disabled="b_top_remove_btn"
				 @click="top_remove_btn_func"
				 >删除</el-button>
			</div>
			
			<div>
				<template>
				  <el-table
				    :data="l_table_data"
				    style="width: 100%;border-color:'#606266'"
				    :default-sort = "{prop: 'date', order: 'descending'}"
            :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
            :cell-style="{color: '#666',fontSize:'14px'}"
            border
            @selection-change="handleSelectionChange"
				  >
					<el-table-column fixed type="selection" width="55"> </el-table-column>
						
				    <el-table-column
						fixed
						align="center"
						prop="shop_name"
						label="店铺名称"
						sortable
						width="260">
				    </el-table-column>
						
				    <el-table-column
						align="center"
						prop="shop_owner"
						label="店主"
						sortable
						width="180">
            <template slot-scope="scope">
              
              <span v-for="(index, item) in scope.row.shop_owner" :key="index" :value="item" :label="item">{{index}}</span>
            </template>
            
				    </el-table-column>
						
						<el-table-column
							align="center"
							prop="is_use"
							label="是否开启"
							sortable
							width="180">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_use"
                  :disabled="true"
                  @change="change_is_use(scope.row)"
                ></el-switch>
              </template>
						</el-table-column>
						
				    <el-table-column
						align="center"
						prop="shop_address"
						label="店铺地址"
						sortable
						width="390"
				      >
				    </el-table-column>
						
						<el-table-column
							align="center"
							prop="room_num"
							label="包间个数"
							sortable
						  >
						</el-table-column>
						
						<el-table-column
							align="center"
							fixed="right"
							label="设备控制"
							width="180"
						  >
							<template slot-scope="scope">
								<el-button type="text" @click="EquipmentControl(scope.row)" icon="el-icon-unlock" size="small">设备控制</el-button>
								<el-button type="text" @click="input_device_func(scope.row)" icon="el-icon-cpu" size="small">设备录入</el-button>
							</template>
						</el-table-column>
						
						<el-table-column
							align="center"
							fixed="right"
							label="操作"
							width="380"
							>
							<template slot-scope="scope">
								
								<el-button @click="show_shop(scope.row)" icon="el-icon-search" type="text" size="small">查看店铺</el-button>
								<el-button @click="change_shop(scope.row)" type="text"  icon="el-icon-edit" size="small">编辑店铺</el-button>
								  <el-button type="text" @click="remove_shop(scope.row)" icon="el-icon-delete" size="small" slot="reference">删除店铺</el-button>						
								<el-divider direction="vertical" style="" content-position="center"></el-divider>
								<el-button type="text" @click="viewRooms(scope.row)" icon="el-icon-house" size="small" style="margin-left: 0px">查看包间</el-button>
								
							</template>
							
						</el-table-column>
						
				    </el-table>
                  
            <el-pagination
                @current-change="change_current_func"
                :current-page="i_current_page"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="i_max_total"
                style="text-align:right; margin-top:15px"
            >
            </el-pagination>
  
					
				</template>
				
				
				  
			</div>
			
		</div>
		
		<!-- 新增店铺 -->
		<el-dialog :visible.sync="b_add_shop_dialog" :fullscreen="b_change_shop_fullscreen" :before-close="this.$dialog_close" :show-close="false" width="1200px">
			
			<div slot="title" class="dialog-title">
				<span style="font-size: 18px; line-height: 24px; color: #303133;">这是新增店铺的表单</span>
				<el-button icon="el-icon-close" class='dialog-title-button' @click="cancel_func"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_change_shop_fullscreen = !b_change_shop_fullscreen"></el-button>
				
			</div>

      <!-- 新增店铺组件 -->
      <!-- <div is="add_shop" @AddShopOkFunc="add_shop_ok_func" :key="ref_components"
       :DialogType="dialog_type" :dSelectShopData="d_select_shop_data"></div> -->
       <el-form :model="d_form" ref="d_form" label-width="100px" class="demo-d_add_form">
         <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="店铺名称"  prop="shop_name">
                <el-input v-model="d_form.shop_name" :disabled="b_disabled" placeholder="请输入店铺名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="店主" prop="shop_owner" >
                <el-select v-model="d_form.shop_owner" clearable :disabled="b_disabled" placeholder="请选择店主" style="width:100%">
                  <el-option
                    v-for="item in l_all_user_name"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username"
                  > 
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="店铺成员" prop="user_list" >
                <el-select v-model="d_form.user_list" clearable multiple :disabled="b_disabled" placeholder="请选择店铺成员" style="width:100%">
                  <el-option
                    v-for="item in l_all_user_name"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username"
                  > 
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="打扫人员" prop="user_list" >
                <el-select v-model="d_form.shop_clean_worker_user_list" clearable multiple :disabled="b_disabled" placeholder="请选择店铺成员" style="width:100%">
                  <el-option
                    v-for="item in l_all_user_name"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username"
                  > 
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="维修人员" prop="user_list" >
                <el-select v-model="d_form.shop_repair_worker_user_list" clearable multiple :disabled="b_disabled" placeholder="请选择店铺成员" style="width:100%">
                  <el-option
                    v-for="item in l_all_user_name"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username"
                  > 
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="更换玩法人员" prop="user_list" >
                <el-select v-model="d_form.shop_change_play_user_list" clearable multiple :disabled="b_disabled" placeholder="请选择店铺成员" style="width:100%">
                  <el-option
                    v-for="item in l_all_user_name"
                    :key="item.id"
                    :value="item.id"
                    :label="item.username"
                  > 
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="打扫时间" prop="shop_clean_time" >
                <el-input-number v-model="d_form.shop_clean_time" :min="5" label="描述文字" :disabled="b_disabled"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="更换玩法时间" prop="shop_change_play_time" >
                <el-input-number v-model="d_form.shop_change_play_time" :min="5" label="描述文字" :disabled="b_disabled"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="维修时间" prop="shop_repair_time" >
                <el-input-number v-model="d_form.shop_repair_time" :min="5" label="描述文字" :disabled="b_disabled"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="预定范围" prop="allow_user_book_room_time" >
                
                <el-input-number v-model="d_form.allow_user_book_room_time" :min="5" label="描述文字" :disabled="b_disabled">
                 
                </el-input-number>
                <el-tooltip effect="dark" content="用户可以预定的时间范围(单位:分钟), 例如设置30,则用户只能提前30分钟对包间进行预订" placement="top">
                    <i class="el-icon-info"></i>
                </el-tooltip>

              </el-form-item>

            </el-col>

            <el-col :span="24">
              <el-form-item label="店铺地址" prop="shop_address" >
                <el-input v-model="d_form.shop_address" placeholder="请输入店铺地址" :disabled="b_disabled"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="包夜区间" prop="shop_night_interval" >
                <el-time-picker
                  is-range
                  :disabled="b_disabled"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  v-model="d_form.shop_night_interval"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
                </el-time-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="打卡距离" prop="shop_punch_distance">
                <el-input-number v-model="d_form.shop_punch_distance" :min="300" label="描述文字" :disabled="b_disabled"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="地域选择" prop="shop_area" >
                <el-cascader :options="china_area_data" clearable v-model="d_form.shop_area" :disabled="b_disabled"></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="坐标选择" prop="shop_coordinate" >
                
                <el-input v-model="d_form.shop_coordinate" placeholder="请选择区域" :disabled="b_disabled"
                @focus="select_coordinate"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否启用" prop="is_use">
                <el-switch v-model="d_form.is_use" :disabled="b_disabled"></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="4小时套餐" prop="enable_four_hour">
                <el-switch v-model="d_form.enable_four_hour" :disabled="b_disabled"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="8小时套餐" prop="enable_eight_hour">
                <el-switch v-model="d_form.enable_eight_hour" :disabled="b_disabled"></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="自助更换玩法" prop="is_self_change_play">
                <el-switch v-model="d_form.is_self_change_play" :disabled="b_disabled"></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="测试店铺" prop="is_test_shop">
                <el-switch v-model="d_form.is_test_shop" :disabled="b_disabled"></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="店铺权重" prop="shop_weights">
                <el-input-number v-model="d_form.shop_weights" :min="1" label="描述文字" :disabled="b_disabled"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="店铺评分" prop="shop_score">
                <div class="block" style="margin-top: 12px;">
                  <el-rate v-model="d_form.shop_score" :allow-half="true" :colors="['#99A9BF', '#F7BA2A', '#FF9900']" :disabled="b_disabled"> </el-rate>
                </div>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label="wifi名" prop="shop_wifi_name">
                <el-input v-model="d_form.shop_wifi_name" placeholder="请输入wifi名称" :disabled="b_disabled"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="wifi密码" prop="shop_wifi_password">
                <el-input v-model="d_form.shop_wifi_password" placeholder="请输入wifi密码" :disabled="b_disabled"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="美团ID" prop="mei_tuan_shop_uuid">
                <el-select v-model="d_form.mei_tuan_shop_uuid" placeholder="请选择" :disabled="b_disabled">
                    <el-option
                      v-for="item in l_meituan_uuid"
                      :key="item.open_shop_uuid"
                      :label="item.shop_name"
                      :value="item.open_shop_uuid">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="店铺所属" prop="shop_belong">
                <el-select v-model="d_form.shop_belong" placeholder="请选择店铺所属关系" :disabled="b_disabled">
                  <el-option
                  v-for="item in shopBelong"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                  >
                  </el-option>

                </el-select>
              </el-form-item>
            </el-col>
   
            <el-col :span="24">
              <el-form-item label="上传主图(1张)"> 
                <el-upload
                  :disabled="b_disabled"
                  action= ''
                  list-type="picture-card"
                  ref='upload'
                  :before-remove="remove_main_img"
                  :limit=1
                  :http-request="upload_main_img"
                  :file-list="shop_main_list"
                  
                >
                <i class="el-icon-plus"></i>
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>

              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="轮播图(1-5张)" prop="img_list"> 
                <el-upload
                  :disabled="b_disabled"
                  action= ''
                  list-type="picture-card"
                  ref='upload'
                  :before-remove="handleRemove"
                  :limit=5
                  :http-request="myUpload"
                  :file-list="img_list"
                  
                >
                <i class="el-icon-plus"></i>
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>

              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" @click="submitForm('d_form')" :disabled="b_disabled">{{ s_btn_name }}</el-button>
                <el-button @click="cancel_func">取消</el-button>
              </el-form-item>
            </el-col>
         </el-row>
       </el-form>
		</el-dialog>

    <!-- 坐标选择弹窗 -->
    <el-dialog :key="ref_components" :visible.sync="b_coordinate_dialog" :fullscreen="b_show_coordinate_fullscreen" :before-close="this.$dialog_close" :show-close="false" width="1200px">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">选择坐标</span>
          <el-button icon="el-icon-close" class='dialog-title-button' @click="select_cancel_func"></el-button>
          <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_coordinate_fullscreen = !b_show_coordinate_fullscreen"></el-button>
      </div>

      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="" class="from-label" >
            <el-input size="small" v-model="search_coordinate_info" placeholder="请输入店铺名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="find_coordinate_info" size="small" icon="el-icon-search">查询</el-button>
          
        </el-form-item>

        <el-form-item>
          <div id="info">当前点击坐标为：<span id="position">{{s_coordinate_info}}</span></div>
        </el-form-item>
        
        <el-form-item>
          <div >
            <div id="container" style="width:100%;height:550px;"> </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="select_coordinate_submit" :disabled="b_disabled">{{ s_btn_name }}</el-button>
          <el-button @click="select_cancel_func">取消</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>

    <!-- 设备录入 -->
    <el-dialog :visible.sync="b_input_device_dialog" :fullscreen="b_input_device_fullscreen" :before-close="this.$dialog_close" :show-close="false">
  
			<div slot="title" class="dialog-title">
				<span style="font-size: 18px; line-height: 24px; color: #303133;">这是设备录入的表单</span>
				<el-button icon="el-icon-close" class='dialog-title-button' @click="b_input_device_dialog = false"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_input_device_fullscreen = !b_input_device_fullscreen"></el-button>
			</div>

      <el-form :model="deviceData" ref="deviceData" label-width="100px" @class="demo-deviceData">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="设备名称" prop="device_name">
              <el-input v-model="deviceData.device_name" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="设备ID" prop="device_id">
              <el-input v-model="deviceData.device_id" placeholder="请输入设备ID"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="父级网关ID" prop="device_parent_gateway">
              <el-input v-model="deviceData.device_parent_gateway" placeholder="请输入父级网关ID(空调遥控必填)"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="设备类型" prop="device_type">
              <el-select v-model="deviceData.device_type" clearable  placeholder="请选设备类型">
                <el-option
                  v-for="item in deviceType"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
		  <div slot="footer" class="dialog-footer">
		    
		    <el-button type="primary" @click="input_device_cancel_func">取 消</el-button>
		    <el-button type="primary" @click="input_device_define_func">确 定</el-button>
		  </div>
		
		</el-dialog>

    <!-- 设备控制弹窗 -->
    <el-dialog :visible.sync="bEquipmentControlDialog" :fullscreen="bEquipmentControlFullscreen" :before-close="this.$dialog_close" :show-close="false" width="500px">
  
			<div slot="title" class="dialog-title">
				<span style="font-size: 18px; line-height: 24px; color: #303133;">设备控制</span>
				<el-button icon="el-icon-close" class='dialog-title-button' @click="bEquipmentControlDialog = false"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bEquipmentControlFullscreen = !bEquipmentControlFullscreen"></el-button>
			</div>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>电路控制</el-divider>
          <el-button type="primary" @click="PowerOn">断路器通电</el-button>
          <el-button type="primary" @click="PowerLoss">断路器断电</el-button>
        </el-col>

        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>空调控制</el-divider>
          <el-button type="primary" @click="OpenAirCondition">开启空调</el-button>
          <el-button type="primary" @click="CloseAirCondition">关闭空调</el-button>
        </el-col>

        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>门锁控制</el-divider>
          <el-button type="primary" @click="OpenDoor">开门</el-button>
        </el-col>

      </el-row>

		  <div slot="footer" class="dialog-footer">
		    
		    <el-button type="primary" @click="bEquipmentControlDialog = false">关 闭</el-button>
		  </div>
		
		</el-dialog>


	</div>
	
</template>

<script>
	import add_shop from '../components/shop/add_shop.vue'
  import show_shop from '../components/shop/show_shop.vue';
  import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'

	export default {
		name:"shop_list",

		components: {
      add_shop,
      show_shop
    },

		data() {
			return {
        china_area_data: regionData,

        // 刷新组件key
        ref_components: 1,

        // 弹窗属性
        dialog_type: 1,

        // total 分页最大值
        i_max_total: 10,
       
				b_top_change_btn: true,
				b_top_find_btn: true,
				b_top_remove_btn: true,
		
				// 新增店铺表单
				b_add_shop_dialog: false,
				// 是否全屏店铺表单
				b_add_shop_fullscreen: false,
				
				// 查看店铺表单
				b_show_shop_dialog: false,
				// 是否全屏查看店铺表单
				b_show_shop_fullscreen: false,
				
				// 修改店铺表单
				b_change_shop_dialog: false,
				// 是否全屏修改店铺表单
				b_change_shop_fullscreen: false,

				// 分页 首次展示第几页
				i_current_page: 1,
				
				ShopListFromLine: {
						ShopName: '',
						ShopDir: '',
				},

				props: { multiple: true },
				
        
				// 搜索后的数据表单
				l_table_data: [],
				
        // 多选事件
				multipleSelection: [],

        // 查看店铺的当前店铺数据
        d_now_show_shop_data: {},

        // 当前选中的行数据
        d_select_shop_data: {},

        // 新增数据的表单
        d_add_form: {
          is_use: false,
          enable_four_hour: true,
          enable_eight_hour: true,
          shop_coordinate: '',
        },

        // 店铺表单数据
        d_form: {},
				
        // 店铺成员列表
        l_all_user_name: [],
        b_disabled: false,
        shop_main_list:[],
        img_list:[],
        dialogVisible: false,
        dialogImageUrl: '',
        s_btn_name: '',

        // 美团uuid
        l_meituan_uuid: [],

        b_coordinate_dialog: false,
        b_show_coordinate_fullscreen: false,
        search_coordinate_info: '',

        bEquipmentControlDialog: false,
        bEquipmentControlFullscreen: false,
        dEquipmentControlData: {},

        map: null,

        // 坐标数据
        l_coordinate_data: [],
        s_coordinate_info: '请选择坐标',

        // 录入设备的表单
        b_input_device_dialog: false,
        // 是否全屏录入设备表单
        b_input_device_fullscreen: false,
        // 设备录入弹窗
        deviceData: {},
        // 设备类型
        deviceType: [
          {value: 0, label: '门锁'},
          {value: 1, label: 'Switch断路器Zigbee'},
          {value: 2, label: '空调红外'},
          {value: 3, label: '智能开关Zigbee'},
          {value: 4, label: '智能插座Zigbee'},
          {value: 5, label: '智能空开Zigbee'},
          {value: 6, label: '室内应急灯(Switch)'},
        ],

        // 店铺所属类型
        shopBelong: [
          {value: 'A0', label: '棋牌-直营'},
          {value: 'A1', label: '棋牌-加盟'},
          {value: 'A2', label: '棋牌-入驻'},
          {value: 'A3', label: '棋牌-记账'},
          {value: 'A4', label: '棋牌-代理'},
          {value: 'B0', label: '台球-直营'},
          {value: 'B1', label: '台球-加盟'},
          {value: 'B2', label: '台球-入驻'},
          {value: 'B3', label: '台球-记账'},
          {value: 'B4', label: '台球-代理'},
        ]
			};
		},
		mounted() {
			// this.tableData = JSON.parse(JSON.stringify(this.oriTableData));
      // 请求后端数据
      this.ref_table_data()

      if(this.map != null){
          // 如果非空 则销毁地图
          this.map.destroy();
      }
      
		},
		
		methods: {
      // 选择坐标触发事件
      select_coordinate(){
        // 判断map是否为空
        if(this.map != null){
          // 如果非空 则销毁地图
          this.map.destroy();
        }
        this.map = null
        this.ref_components += 1
        this.s_coordinate_info = '请选择坐标',
        this.b_coordinate_dialog = true;
       
        this.$nextTick(() => {
          this.map = this.initMap()
        })
        
      },

      // 地图搜索事件
      find_coordinate_info(){
        // this.initMap()
      },

      // 确定事件
      select_coordinate_submit(){
        // this.s_coordinate_info = this.search_coordinate_info
        this.b_coordinate_dialog = false;
        this.d_form.shop_coordinate = this.s_coordinate_info
      },
      
      // 取消事件
      select_cancel_func(){
        // 销毁地图
        this.map.destroy();
        this.map = null
        this.b_coordinate_dialog = false;
      },
      
      // 初始化地图
      initMap() {
        var _this = this;
        console.log(_this.d_form.shop_coordinate)

        // 如果有坐标 进行点坐标标记
        if (_this.d_form.shop_coordinate != ''){
          var l_coordinate_info = _this.d_form.shop_coordinate.split(',')
          var b_coordinate = true
        }else{
          var l_coordinate_info = [34.269980,108.947229]
          var b_coordinate = false
        }
        
        var center = new TMap.LatLng(l_coordinate_info[0],l_coordinate_info[1]);
        
        var map = new TMap.Map("container", {
          rotation: 0,//设置地图旋转角度
          pitch:0, //设置俯仰角度（0~45）
          zoom:12,//设置地图缩放级别
          center: center//设置地图中心点坐标
        });

        var markerLayer = null;
        // 创建地图上的标记
        var markerLayer = new TMap.MultiMarker({
            id: 'marker-layer',
            map: map,
        });
        
        // 如果有坐标 进行点坐标标记
        if (b_coordinate === true){
          markerLayer.add({
            position: new TMap.LatLng(l_coordinate_info[0], l_coordinate_info[1]),
          });
        }
       
        // 地图点击事件
        map.on("click",function(evt){

          // 清空markerLayer
          // markerLayer.clearMarkers();
          // 删除上一个mark
          if (markerLayer){
            console.log(markerLayer)
            markerLayer.setMap(null)
            markerLayer = null
            markerLayer = new TMap.MultiMarker({
              id: 'marker-layer',
              map: map
            });
          }

          markerLayer.geometries = [];
          var lat = evt.latLng.getLat().toFixed(6);
          var lng = evt.latLng.getLng().toFixed(6);
          // position.innerHTML = lat + "," + lng;
          _this.s_coordinate_info = lat + "," + lng;
          console.log(this.s_coordinate_info)
          console.log(evt.latLng)
          markerLayer.add({
            position: evt.latLng
          });
        })

        return map;

      },

      // 获取店铺成员数据
      async get_all_user_name() {
        var d_user_data = {"is_business": 1}
        let res = await this.$axios.get('/api/users/', {params: d_user_data})
        this.l_all_user_name = res.data
      },

      async getShopUuidInfo(){
        var d_params = {
          'shop_uuid': 'YDKJQUERYMEITUANSHOPUUID'
        }
        let res = await this.$axios.get('/api/query_shop_uuid/', {params: d_params})
        this.l_meituan_uuid = res.data.data
      },  

      // 刷新表单接口
      async ref_table_data(){
        var d_params = {
          'page': this.i_current_page,
          'page_size': 10
        }

        if (this.ShopListFromLine.ShopName != ''){
          d_params['shop_name'] = this.ShopListFromLine.ShopName
        }

        if (this.ShopListFromLine.ShopDir != ''){
          d_params['shop_address'] = this.ShopListFromLine.ShopDir
        }

        // if (this.ShopListFromLine.UserName != ''){
        //   d_params['shop_owner'] = this.ShopListFromLine.UserName
        // }

        let res = await this.$axios.get('/api/shops/', {params: d_params})
        // 处理区域信息
        for (var i = 0; i < res.data.results.length; i++){
          res.data.results[i].shop_area = res.data.results[i].shop_area.split(',')
          
          res.data.results[i].shop_night_interval = [
            res.data.results[i].shop_night_start_time,
            res.data.results[i].shop_night_end_time
          ]
        }

        this.l_table_data = res.data.results
        this.i_max_total = res.data.count

        console.log(this.l_table_data)
        console.log(333)

      },

      // // 解析位置信息
      // parse_coordinate_info(l_data){
      //   for (var i = 0; i < l_data.length; i++){
          
      //     var s_shop_coordinate = l_data[i].shop_coordinate
      //     l_data[i].shop_coordinate = [s_shop_coordinate, '']
      //   }

      //   return l_data
      
      // },

      // 监听输入
      forceUpdate(){
				this.$forceUpdate();
			},

      // 查询数据
			queryData() {
        this.ref_table_data()
			},
			
			// 重置数据
			onReset(){
				this.ShopListFromLine ={
						ShopName: '',
						ShopDir: '',
				}
        this.ref_table_data()
			},
			
      // 多选触发事件
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val.length)
				
				if (val.length === 0){
					this.b_top_change_btn = true,
					this.b_top_find_btn = true,
					this.b_top_remove_btn = true
					return
				}
				
				if (val.length === 1){
					this.b_top_change_btn = false,
					this.b_top_find_btn = false,
					this.b_top_remove_btn = false
					return
				}
				
				if (val.length > 1){
					this.b_top_change_btn = true,
					this.b_top_find_btn = true,
					this.b_top_remove_btn = false
					return
				}
			},
			
      // 顶部删除操作
			top_remove_btn_func(){
				console.log('删除操作')
				console.log(this.multipleSelection)
				
			},
			
			// 新增店铺
			add_shop(){
        this.d_form = JSON.parse(JSON.stringify(this.d_add_form))
			
        this.get_all_user_name()
        this.getShopUuidInfo()
        this.img_list = []
        
        this.d_form.img_list = []
        
        this.b_disabled = false
        this.s_btn_name = '保存'
        this.dialog_type = 1
        this.b_add_shop_dialog = true
			},

      // 修改店铺
			change_shop(d_info){
        // this.ref_components += 1
				// this.d_select_shop_data = d_info
        this.get_all_user_name()
        this.getShopUuidInfo()
        this.shop_main_list = [{url: d_info.shop_main_img}]

        this.img_list = []
        var l_img_list = d_info.img_list
        for (var i_index=0; i_index<l_img_list.length; i_index++){
          var url = l_img_list[i_index]
          // 显示图片的列表
          this.img_list.push({url: url})
        }
        
        this.d_form = JSON.parse(JSON.stringify(d_info))

        // 获取shop_owner的第一个key值
        var s_shop_owner = this.d_form.shop_owner
        var s_shop_owner_key = Object.keys(s_shop_owner)[0]
        // 转换为int类型
        var i_shop_owner_key = parseInt(s_shop_owner_key)
        this.d_form.shop_owner = i_shop_owner_key
        this.b_disabled = false
        this.s_btn_name = '保存'
        this.dialog_type = 2
        this.b_add_shop_dialog = true
			},
			

			// 查看店铺
			show_shop(d_info){
        // this.ref_components += 1
				// this.d_select_shop_data = d_info
        this.get_all_user_name()
        this.getShopUuidInfo()
        console.log(d_info)

        this.shop_main_list = [{url: d_info.shop_main_img}]

        this.img_list = []
        var l_img_list = d_info.img_list
        for (var i_index=0; i_index<l_img_list.length; i_index++){
          var url = l_img_list[i_index]
          // 显示图片的列表
          this.img_list.push({url: url})
        }

        this.b_disabled = true
        this.d_form = JSON.parse(JSON.stringify(d_info))

        // 获取shop_owner的第一个key值
        var s_shop_owner = this.d_form.shop_owner
        var s_shop_owner_key = Object.keys(s_shop_owner)[0]
        // 转换为int类型
        var i_shop_owner_key = parseInt(s_shop_owner_key)
        this.d_form.shop_owner = i_shop_owner_key
        console.log(this.d_form)
        // this.d_form.shop_owner = d_info.keys
        this.s_btn_name = '禁止操作'
        this.dialog_type = 3
				this.b_add_shop_dialog = true
			},

      // 删除店铺
      remove_shop(d_data){
        this.$confirm('此操作将永久删除该店铺吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.on_delete_submit(d_data)
          
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },

		
			// 执行删除删除店铺
			async on_delete_submit(d_data){
        let res = await this.$axios.delete('/api/shops/' + d_data.shop_id + '/')
      
        if (res.status === 204){
          this.ref_table_data()
          this.$message({
            type: 'success',
            message: '删除成功!'
            });
          }else {
            this.$message({
              type: 'error',
              message: '删除失败!请检查是否已有其他关联或使用'
            });
          }	
			},

			// 分页触发事件
			change_current_func(i_index){
				console.log(i_index)
        var _this = this
        _this.i_current_page = i_index
        var d_params = {
          'page': i_index,
          'page_size': 10
        }
        console.log(d_params)
        this.$axios.get('/api/shops/', {params: d_params}).then(
        function(res){
          
          _this.i_max_total = res.data.count
          _this.l_table_data = res.data.results
        }
        ).catch(function(error){
          console.log(error)
        })

			},

      // 删除主图
      async remove_main_img(){
        let s_remove_url = this.d_form.shop_main_img
        await this.$remove_common(s_remove_url)
      },

      // 上传主图
      async upload_main_img(option){
        const res = await this.$upload_common(option)
        this.d_form.shop_main_img = res.data.s_url
      },

      // 删除轮播
      async handleRemove(file, fileList){
        let s_remove_url = file.url
        await this.$remove_common(s_remove_url)
        this.d_form.img_list.splice(fileList.indexOf(file), 1)
      },

      // 上传轮播
      async myUpload(option){
        const res = await this.$upload_common(option)
        this.d_form.img_list.push(res.data.s_url)
      },
      
      // 处理区域数据
      handle_area_data(){
        console.log(this.d_form.shop_area)
        console.log(typeof(this.d_form.shop_area))

        // 判断为 null
        if (this.d_form.shop_area.length == 1){
          this.d_form.shop_area = ''
        }
        // 判断是否是字符串
        else if (typeof(this.d_form.shop_area) == 'string'){
          
          console.log(this.d_form.shop_area)
        }
        else {
          this.d_form.shop_area = this.d_form.shop_area.join(',')
        }
      },

      // 提交表单事件
      async submitForm(){
        this.handle_area_data()

        // this.d_form.shop_owner = parseInt(Object.keys(this.d_form.shop_owner)[0])
        // this.d_form.updater_user = Object.keys(this.d_form.updater_user)[0]
        this.d_form.updater_user = parseInt(window.sessionStorage.getItem('id'))
        this.d_form.shop_night_start_time = this.d_form.shop_night_interval[0]
        this.d_form.shop_night_end_time = this.d_form.shop_night_interval[1]
        if (this.dialog_type === 1){
          let s_url = '/api/shops/'
          let d_data = this.d_form
          let res = await this.$axios.post(s_url, d_data)
          this.request_waring(res)
        }else if (this.dialog_type === 2){
          // 深拷贝 d_form
          let d_data = JSON.parse(JSON.stringify(this.d_form))
          
          // console.log(d_data)
          // d_data.shop_owner = parseInt(Object.keys(d_data.shop_owner)[0])
          // console.log(d_data)

          let s_url = '/api/shops/' + this.d_form.shop_id + '/'
          let res = await this.$axios.put(s_url, d_data)
          this.request_waring(res)
        }
      },

      // 取消 也有 关闭窗口 刷新事件
      cancel_func(){
        this.d_form = {}
        this.b_add_shop_dialog = false
        this.img_list = []
        this.shop_main_list = []
      },

      // 请求警告
      request_waring(res){
        if (res.status === 201 || res.status === 200){
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.cancel_func()
          
          this.ref_table_data()
        
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
      },

      input_device_func(val){
        this.b_input_device_fullscreen = false
        this.b_input_device_dialog = true
        this.deviceData = {}
        // 设备录入的包间id
        this.deviceData.shop_id = val.shop_id
      },

      // 取消设备录入按钮绑定事件
      input_device_cancel_func(){
        this.b_input_device_fullscreen = true
        this.b_input_device_dialog = false
      },

      // 确定录入设备按钮绑定事件
      async input_device_define_func(){
        this.b_input_device_fullscreen = true
        this.b_input_device_dialog = false

        await this.$axios.post('/api/device/', this.deviceData).then(
          res => {
            this.$message({
              message: '录入成功',
              type: 'success'
            })
            this.ref_table_data()
          }
        ).catch(
          err => {
            console.log(err)
            console.log(err.response)
            this.$message({
              message: '录入失败' + err.response.data.message,
              type: 'error'
            })
          }
        )
      
    },

    // 设备控制
    EquipmentControl(d_info){
      this.bEquipmentControlFullscreen = false
      this.bEquipmentControlDialog = true
      this.dEquipmentControlData = d_info
    },

    // 断路器断电
    async PowerLoss(){
      var sShopId = this.dEquipmentControlData.shop_id
      await this.$axios.post('/api/breaker/?shop_id=' + sShopId, {"is_open": false}).then(res => {
          this.$message({
            message: '断电成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '断电失败' + err.response.data.message,
            type: 'error'
          })
      })
    },

    // 断路器通电
    async PowerOn(){
      var sShopId = this.dEquipmentControlData.shop_id
      await this.$axios.post('/api/breaker/?shop_id=' + sShopId, {"is_open": true}).then(res => {
          this.$message({
            message: '通电成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '通电失败' + err.response.data.message,
            type: 'error'
          })
      })
    },

    // 开门
    async OpenDoor(){
      var sShopId = this.dEquipmentControlData.shop_id
      await this.$axios.post('/api/unlock/?shop_id=' + sShopId).then(res => {
          this.$message({
            message: '开门成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '开门失败' + err.response.data.message,
            type: 'error'
          })
      })
      
    },

    // 开启空调
    async OpenAirCondition(){
      var sShopId = this.dEquipmentControlData.shop_id
      await this.$axios.post('/api/air/?shop_id=' + sShopId, {"PowerOn": 0}).then(res=>{
        this.$message({
          message: '开启空调成功',
          type: 'success'
        })
      }).catch(err=>{
        this.$message({
          message: '开启空调失败' + err.response.data.message,
          type: 'error'
        })
      })
      
    },

    // 关闭空调
    async CloseAirCondition(){
      var sShopId = this.dEquipmentControlData.shop_id
      await this.$axios.post('/api/air/?shop_id=' + sShopId, {"PowerOff": 0}).then(res=>{
        this.$message({
          message: '关闭空调成功',
          type: 'success'
        })
      }).catch(err=>{
        this.$message({
          message: '关闭空调失败' + err.response.data.message,
          type: 'error'
        })
      })
    },

    // 查看包间
    viewRooms(d_info){
      // 跳转到包间管理页面
      this.$router.push({path: '/room_list', query: {shop_id: d_info.shop_id, shop_name: d_info.shop_name}})
    },

	}
}
</script>

<style>
	.shop-list-main {
		background-color: #fff;
		padding: 12px 16px;
		/* height: 80vh; */
	}
	
	.from-label {
		
		font-weight: 700;
		color: #606266;
		/* font-size:14px; */
		padding: 0 12px 0 0; 
		text-align: right; 
		vertical-align: middle;
		margin-bottom: 22px;
	}
	
	.dialog-title-button {
		float: right;
		padding: 10px;
		border: none;
    border-style: none; 
	}

	
</style>
